export default __webpack_public_path__ + "static/langgraph-4e667c2831d3877d705c40eed3e80f95.png";